import { COMMENTS as COMMENTS_FLAG } from './feature-flags'
import {
  ACCOUNT,
  COMMENTS,
  USER_ADMIN
} from './controllers'
import {
  URL_TRAINING,
  URL_CORPORATE,
  URL_EMPLOYMENT,
  URL_DOCUMENTS,
  URL_COMPANY_SECRETARY,
  URL_TEAMS,
  URL_FAQ,
  URL_USER_GUIDES
} from 'constants/links'

export const MENU_ITEMS = [
  { type: 'link', title: 'Annotations', target: COMMENTS, position: 'side', params: {}, disabled: !COMMENTS_FLAG },
  { type: 'link', title: 'Team', url: URL_TEAMS, position: 'side', params: {} },
  { type: 'link', title: 'User Management', target: USER_ADMIN, position: 'side-bottom', params: {}, requiresLogged: true },
  { type: 'link', title: 'My Account', target: ACCOUNT, position: 'side-bottom', params: {}, requiresLogged: true },
  { type: 'link', title: 'FC Corporate', position: 'solution', url: URL_CORPORATE },
  { type: 'link', title: 'FC Employment', position: 'solution', url: URL_EMPLOYMENT },
  { type: 'link', title: 'FC Training', position: 'solution', url: URL_TRAINING },
  { type: 'link', title: 'FC Documents', position: 'solution', url: URL_DOCUMENTS },
  { type: 'link', title: 'Company Secretary', position: 'solution', url: URL_COMPANY_SECRETARY },
  {
    type: 'group',
    title: 'Help',
    items: [
      { type: 'link', title: 'User Guides', url: URL_USER_GUIDES, external: true },
      { type: 'link', title: 'FAQ', url: URL_FAQ, params: {} }
    ],
    position: 'side'
  }
]
